import "./Header.css";
import NavBar from "./NavBar";
import Hero from "./Hero";

const Header = () => {
  return (
    <>
      <NavBar />
      <Hero />
    </>
  );
};

export default Header;
